<template>
	<TopTab />
	<div>
		<router-view />
	</div>
</template>

<script setup>
import TopTab from './TopTab.vue'

</script>

<style lang="scss" scoped>

</style>
